import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "px-10" }
const _hoisted_2 = { class: "pb-10" }
const _hoisted_3 = { class: "font-size-12-600 font-black" }
const _hoisted_4 = { class: "font-size-12-600 font-black" }
const _hoisted_5 = { class: "font-size-12-600 font-black" }
const _hoisted_6 = { class: "font-size-12-600 font-black" }
const _hoisted_7 = { class: "font-size-12-600 font-black" }
const _hoisted_8 = { class: "font-size-12-600 font-black" }

import Icon from "@/components/Icons/Icon.vue";
import CreatedBy from "@/components/custom/CreatedBy.vue";
import {computed, onMounted, ref} from 'vue'
import FlexContainer from "@/views/ClientComponents/MedicalAlerts/Partials/FlexContainer.vue";
import {medicalAlertsService} from "@/api/services/medicalAlerts";
import {useRoute, useRouter} from "vue-router";
import {useSettingsStore} from "@/api/store/settings";
import getAgeAndDuration from "@/views/ClientComponents/MedicalAlerts/GetAgeAndDuration";
import moment from "moment/moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewMedicalAlert',
  setup(__props) {

const settingsStore = useSettingsStore();
const router = useRouter();
const route = useRoute();

const formState = ref({
  name: null,
  description: null,
  type: null,
  created_by: null,
  date_from: null,
  date_to: null,
  method: null,
  status: null
})

const setIcon = computed(() => {
  return formState.value.created_by === 'client' ? 'client-icon' : 'blue-practitioner-icon'
})

const getDob = computed(() => {
  return route.query.dob ? route.query.dob : null
})

const isMethodDate = computed(() => {
  return formState.value.method === 'date'
})

const formattedDate = (value: string | number, format = 'DD MMM YYYY') => {
  return moment(value).format(format)
}

const fetchMedicalAlert = () => {
  
  medicalAlertsService.show(route.params.id).then(({data}) => {
    formState.value = data
    
  })
}

onMounted(fetchMedicalAlert)

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_container, { class: "px-0 pt-0 pb-5" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "text-right px-4 pt-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'medical-alerts' })))
      }, [
        _createVNode(Icon, {
          icon: "cross-icon",
          color: "primaryColor"
        })
      ]),
      _createElementVNode("section", _hoisted_1, [
        _createVNode(CreatedBy, { icon: setIcon.value }, null, 8, ["icon"]),
        _createElementVNode("div", null, [
          _createVNode(_component_v_card_title, { class: "px-0 py-0 pt-3 pb-4 font-size-18-600 font-black" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(formState.value.name), 1)
            ]),
            _: 1
          }),
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(formState.value.description), 1)
          ]),
          _createVNode(FlexContainer, { title: "Type" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(formState.value.type), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(FlexContainer, { title: "Status" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(formState.value.status), 1)
            ]),
            _: 1
          }),
          (isMethodDate.value)
            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
            : _createCommentVNode("", true),
          (isMethodDate.value)
            ? (_openBlock(), _createBlock(FlexContainer, {
                key: 1,
                title: "Date From"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(formattedDate(formState.value.date_from)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isMethodDate.value)
            ? (_openBlock(), _createBlock(_component_v_divider, { key: 2 }))
            : _createCommentVNode("", true),
          (isMethodDate.value)
            ? (_openBlock(), _createBlock(FlexContainer, {
                key: 3,
                title: "Date To"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(formState.value.date_to && formState.value.status !== 'Ongoing' ? formattedDate(formState.value.date_to) : formattedDate(_unref(moment)())), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider),
          _createVNode(FlexContainer, { title: "Age" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getAgeAndDuration)(getDob.value, formState.value).age.value) + " old ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(FlexContainer, { title: "Duration" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getAgeAndDuration)(getDob.value, formState.value).duration.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider)
        ])
      ])
    ]),
    _: 1
  }, 512)), [
    [_vShow, formState.value && !_unref(settingsStore).loading]
  ])
}
}

})